import { render, staticRenderFns } from "./slides-item.vue?vue&type=template&id=2fc38d22&scoped=true&"
import script from "./slides-item.vue?vue&type=script&lang=js&"
export * from "./slides-item.vue?vue&type=script&lang=js&"
import style0 from "./slides-item.vue?vue&type=style&index=0&id=2fc38d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc38d22",
  null
  
)

component.options.__file = "slides-item.vue"
export default component.exports